export enum ReturnPolicyType {
  Return = "return",
  Claim = "claim",
  Warranty = "warranty",
  Withdrawal = "withdrawal",
}
